

export class FormularioCliente {

  constructor(

    public nombres: string,
    public apePaterno: string,
    public apeMaterno: string,
    public sexo: string,
    public dni: string,
    public fecnac:string,
    public celular: string,
    public correo: string,
    public comprobante: string,
    public id_proveedor: number,
    public id_empresa: number,
    public check_recibir: boolean,
    public tipoDocEntidad:string,
    public codDepartamento:string,
    public codProvincia:string,
    public codDistrito:string,
    public fechaNacimiento:string,
    public check_inkaclub: boolean,
    public fechaNacBaby: string,
    public codigoDermo: string,
    public mascarilla: string,

  ) { }

}
